module.exports = __webpack_public_path__ + "img/GBYTE.2ae17fe9.svg";